 // Free Gift Product
 $(document).ready(function() {


 	$('.free-gifts-properties-js').empty();

 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});




/* ---------------------------------------------------------------------------
   Cart line removal + quantity, rewritten 2026-08-07.

   The old version addressed lines by variant id (data-line-id renders
   {{ line_item.id }}, which is the variant), never checked response.ok, read
   the ids out of possibly-stale markup, and had no guard against two updates
   running at once. Combined with the duplicate handler that used to sit lower
   in this file, a single click could fire several racing cart writes, which is
   why the main line survived roughly one click in ten.

   This resolves line KEYS from live cart state, sends one update, then verifies
   and retries once. It accepts either a key or a variant id in data-line-id.
   --------------------------------------------------------------------------- */

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false; // one cart mutation at a time

  function isCartPage() {
    return window.location.pathname.replace(/\/+$/, '').split('/').pop() === 'cart';
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      });
  }

  function updateCart(updates) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (data) {
        // The old code skipped this. Shopify answers 422 when the cart moved
        // under you, and that is exactly the intermittent case.
        if (!r.ok) throw new Error((data && (data.description || data.message)) || 'cart/update.js ' + r.status);
        return data;
      });
    });
  }

  /* Find the line to remove, plus its gift lines, in the cart as it is *now*.
     `token` is whatever data-line-id holds: a line key or a variant id. */
  function resolveLines(cart, token, domGiftIds) {
    var wanted = [];
    var giftLines = [];
    var main = null;
    var i;

    for (i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === token) { main = cart.items[i]; break; }
    }
    if (!main) {
      for (i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(token)) { main = cart.items[i]; break; }
      }
    }
    if (!main) return { main: null, keys: [], giftLines: [] };
    wanted.push(main.key);

    // The line's own properties are the authoritative gift list — the DOM is a
    // fallback for markup that has not been re-rendered yet.
    var giftIds = [];
    Object.keys(main.properties || {}).forEach(function (name) {
      if (/free\s*gift/i.test(name) && main.properties[name]) giftIds.push(String(main.properties[name]));
    });
    (domGiftIds || []).forEach(function (gid) {
      if (gid && giftIds.indexOf(String(gid)) === -1) giftIds.push(String(gid));
    });

    giftIds.forEach(function (gid) {
      for (var j = 0; j < cart.items.length; j++) {
        var line = cart.items[j];
        if (wanted.indexOf(line.key) !== -1) continue;
        // A line is a gift because the paid line NAMES it in `_free gift n`, not
        // because it costs nothing. This used to require final_price === 0, and
        // that is the bug Naveed hit: when the automatic discount was not applying,
        // the gifts sat in the cart at $25.00 / $5.95 / $39.00, so none of them
        // looked like a gift any more and removing the paid line left all three
        // behind. The discount then applied to what was left, which is why they
        // turned free the moment the main product went.
        //
        // The old guard was protecting against a real case - the customer buying
        // the same product outright as well - so that is kept, just no longer by
        // price alone: prefer a zero-priced match, and accept a priced one only
        // when it is the ONLY line with that variant, in which case the parent
        // declaring it a gift is unambiguous. Two priced matches stay put rather
        // than guess which one was bought.
        if (String(line.variant_id) !== gid) continue;
        var zeroMatch = line.final_price === 0;
        var soleMatch = cart.items.filter(function (other) {
          return String(other.variant_id) === gid && wanted.indexOf(other.key) === -1;
        }).length === 1;
        if (zeroMatch || soleMatch) {
          wanted.push(line.key);
          giftLines.push(line);
          break;
        }
      }
    });

    return { main: main, keys: wanted, giftLines: giftLines };
  }

  /* How many of each gift variant the cart is entitled to once `overrides` is
     applied - a map of line key to the quantity that line is about to have.

     A paid line claims a gift by naming its variant in `_free gift n`, so a
     gift row is owed the summed quantity of every paid line claiming it. That
     matters because the cart MERGES gift rows: add the 4-bottle pack twice,
     once on subscription and once not, and the three gifts come back as three
     rows of quantity 2 shared by both paid lines. Zeroing those rows when one
     paid line goes stripped the gifts off the paid line that was still there,
     which is what Naveed hit on 28-brow-serum.

     `_free shipping` is a marker for a perk with no product behind it, not a
     claim on a line, and "free shipping" is not "free gift" so it never counts. */
  function giftEntitlements(cart, overrides) {
    var claims = {};
    cart.items.forEach(function (item) {
      var qty = overrides && Object.prototype.hasOwnProperty.call(overrides, item.key)
        ? overrides[item.key]
        : item.quantity;
      if (!(qty > 0)) return;
      Object.keys(item.properties || {}).forEach(function (name) {
        // indexOf, not a regex: an escaping slip once turned this pattern into
        // one that matched nothing and the guard went quietly dead.
        if (String(name).toLowerCase().indexOf('free gift') === -1) return;
        var gid = String(item.properties[name] || '');
        if (!gid) return;
        claims[gid] = (claims[gid] || 0) + qty;
      });
    });
    return claims;
  }

  function showLoader($loader) {
    $loader.removeAttr('hidden');
    $loader.find('.line-item__loader-spinner').removeAttr('hidden');
  }

  function finishLoader($loader, ok) {
    var $spinner = $loader.find('.line-item__loader-spinner');
    var $check = $loader.find('.line-item__loader-mark');
    $spinner.attr('hidden', '');
    if (ok) $check.removeAttr('hidden');
    setTimeout(function () {
      $loader.attr('hidden', '');
      $spinner.attr('hidden', '');
      $check.attr('hidden', '');
    }, 1000);
  }

  function refreshUI() {
    if (isCartPage()) {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      $('.cart-drawer.cart-drawer').removeClass('cart_loading');
    }
  }

  /* ---------------- remove a main line and its gifts ---------------- */

  $(document).on('click', '.link.main-product--true', function (event) {
    event.preventDefault();
    if (busy) return; // a second click used to interleave with the first
    busy = true;

    var $this = $(this);
    var token = String($this.attr('data-line-id') || '').trim();

    var $giftInputs = isCartPage()
      ? $this.parents('.cart-line-item').find('.list-disc input.freegiftId')
      : $this.closest('.line_item_content').find('.product-item-meta__property input.freegiftId');
    var domGiftIds = $giftInputs.map(function () { return $(this).val(); }).get();

    var $loader = $this.closest('.line-item__content-wrapper').find('.line-item__loader');
    showLoader($loader);

    getCart()
      .then(function (cart) {
        var found = resolveLines(cart, token, domGiftIds);
        if (!found.main) throw new Error('line ' + token + ' is no longer in the cart');

        // light up the gift rows too, same as before
        found.keys.forEach(function (key) {
          var line = cart.items.filter(function (i) { return i.key === key; })[0];
          if (!line) return;
          $loader = $loader.add(
            $('[data-line-id="' + line.variant_id + '"], [data-line-id="' + line.key + '"]')
              .first().closest('.line-item, .cart-line-item').find('.line-item__loader')
          );
        });
        showLoader($loader);

        var overrides = {};
        overrides[found.main.key] = 0;
        var claims = giftEntitlements(cart, overrides);

        var updates = {};
        updates[found.main.key] = 0;
        found.giftLines.forEach(function (line) {
          // Never above what the row already holds: handing out a gift is the
          // buy box's job, this only takes back what the removed line claimed.
          updates[line.key] = Math.min(line.quantity, claims[String(line.variant_id)] || 0);
        });
        return updateCart(updates).then(function () { return updates; });
      })
      .then(function (desired) {
        // Verify. If the gift app wrote to the cart at the same moment, one of
        // ours can be lost — that is the bug, so we check instead of assuming.
        // Quantities, not presence: a shared gift row is meant to survive at a
        // lower quantity now, so "still in the cart" is no longer a failure.
        return getCart().then(function (after) {
          var retry = {};
          var missed = false;
          Object.keys(desired).forEach(function (key) {
            var line = after.items.filter(function (i) { return i.key === key; })[0];
            if ((line ? line.quantity : 0) === desired[key]) return;
            retry[key] = desired[key];
            missed = true;
          });
          if (!missed) return;
          return updateCart(retry);
        });
      })
      .then(function () {
        finishLoader($loader, true);
        refreshUI();
      })
      .catch(function (error) {
        console.error('Cart remove failed:', error);
        finishLoader($loader, false);
        refreshUI(); // repaint from real state rather than leave a stale row
      })
      .then(function () { busy = false; });
  });

  /* ---------------- quantity ---------------- */

  function changeQuantity($button, delta) {
    if (busy) return;
    busy = true;

    var $line = $button.closest('.line-item');
    var $loader = $line.find('.line-item__loader');
    var $input = $line.find('.quantity-selector__input');
    var token = String($button.attr('data-line-id') || '').trim();

    var current = parseInt($input.val(), 10);
    if (isNaN(current)) current = 1; // old code could send NaN
    var quantity = Math.max(0, current + delta);

    var domGiftIds = $line.find('.line-item__info input.freegiftId')
      .map(function () { return $(this).val(); }).get();

    showLoader($loader);

    getCart()
      .then(function (cart) {
        var found = resolveLines(cart, token, domGiftIds);
        if (!found.main) throw new Error('line ' + token + ' is no longer in the cart');
        $input.val(quantity);

        // Gifts follow the claims on them. Setting every gift row to THIS
        // line's new quantity threw away a second paid line's claim.
        var overrides = {};
        overrides[found.main.key] = quantity;
        var claims = giftEntitlements(cart, overrides);

        var updates = {};
        updates[found.main.key] = quantity;
        found.giftLines.forEach(function (line) {
          updates[line.key] = claims[String(line.variant_id)] || 0;
        });
        return updateCart(updates);
      })
      .then(function () {
        finishLoader($loader, true);
        refreshUI();
      })
      .catch(function (error) {
        console.error('Cart quantity update failed:', error);
        finishLoader($loader, false);
        refreshUI();
      })
      .then(function () { busy = false; });
  }

  $(document).on('click', '.quantity-selector__button.minus', function (e) {
    e.preventDefault();
    changeQuantity($(this), -1);
  });

  $(document).on('click', '.quantity-selector__button.plus', function (e) {
    e.preventDefault();
    changeQuantity($(this), 1);
  });




 });


 $(document).ready(function() {
 	const productVariantElement = document.querySelector('product-variants');
 	let PreselectedVariantId = $('product-variants').attr('preselected_id');
 	PreselectedVariantId = parseInt(PreselectedVariantId);
 	// if (PreselectedVariantId) {
 	// 	productVariantElement.selectVariant(PreselectedVariantId);
 	// }
	setTimeout(function () {
		if (PreselectedVariantId && productVariantElement) {
			productVariantElement.selectVariant(PreselectedVariantId);
		}
	}, 500);
 });

 function openCity(evt, cityName) {
 	var i, tabcontent, tablinks;
 	tabcontent = document.getElementsByClassName("tabcontent");
 	for (i = 0; i < tabcontent.length; i++) {
 		tabcontent[i].style.display = "none";
 	}
 	tablinks = document.getElementsByClassName("tablinks");
 	for (i = 0; i < tablinks.length; i++) {
 		tablinks[i].className = tablinks[i].className.replace(" active", "");
 	}
 	document.getElementById(cityName).style.display = "block";
 	evt.currentTarget.className += " active";
 }
 $(document).ready(function() {
 	if ($(".customer_main").length > 0) {
 		$('.customer_main').slick({
 			slidesToShow: 3,
 			dots: true,
 			arrows: true,
 			responsive: [{
 					breakpoint: 991,
 					settings: {
 						slidesToShow: 2,
 					}
 				},
 				{
 					breakpoint: 799,
 					settings: {
 						slidesToShow: 1,
 					}
 				}
 			]
 		});
 	}
 });

 $(document).ready(function() {
 	if ($(".tried-tested-video").length > 0) {
 		$('.tried-tested-video').slick({
 			slidesToShow: $('.tested-video-wrapper').attr('data-viewItem') || 4,
 			dots: false,
 			arrows: false,
 			centerMode: false,
 			infinite: true,
 			responsive: [{
 					breakpoint: 998,
 					settings: {
 						slidesToShow: 4,
 						slidesToScroll: 1,
 					},
 				},
 				{
 					breakpoint: 789,
 					settings: {
 						slidesToShow: 3,
 						slidesToScroll: 1,
 						centerMode: false,
 					},
 				}
 			],
 		});
 	}

 	function progressBar(progress) {
 		if (progress == 0) {
 			progress = 10;
 		}
 		var progressBar = $('.progress-bar__inner');
 		progressBar.css('width', progress + '%');
 	}

 	progressBar(10);

 	$('.tried-tested-video').on('beforeChange', function(event, slick, currentSlide, nextSlide) {

 		var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
 		progressBar(calc);
 	});

 	$(document).on("click", ".tried-tested-video .video-control", function() {

 		var clickedControl = $(this);
 		var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
 		var videoHtml = clickedControl.closest('.video-item').html();

 		// Move the video to the main popup
 		$('.tested-main-popup').html(videoHtml);

 		// Pause all other videos
 		$('.popup-video video').not(clickedVideo).each(function() {
 			this.pause();
 			$(this).siblings('.video-control').removeClass('btnhide');
 		});

 		// Toggle play/pause and update control icon for the video in the main popup
 		var mainPopupVideo = $('.tested-main-popup video')[0];
 		if (mainPopupVideo.paused) {
 			mainPopupVideo.play();
 			$('.tested-main-popup .video-control').addClass('btnhide');
 		} else {
 			mainPopupVideo.pause();
 			$('.tested-main-popup .video-control').removeClass('btnhide');
 		}

 		// Activate the main popup
 		$('.tested-main-popup').addClass('video-active');
 		$('body').addClass('video-popup-active');
 	});

 	$(document).on("click", ".tested-main-popup .icon-close", function() {
 		// Pause and close the video in the main popup
 		var mainPopupVideo = $('.tested-main-popup video')[0];
 		if (mainPopupVideo) {
 			mainPopupVideo.pause();
 			$('.tested-main-popup .video-control').removeClass('btnhide');
 		}

 		$('body').removeClass('video-popup-active');
 		$('.tested-main-popup').removeClass('video-active');
 		$('.tested-main-popup').empty();
 	});

 	$(document).on("click", ".tested-main-popup .icon-volume", function() {
 		console.log("this = ", this);
 		var mainPopupVideo = $(this).parents('.tested-main-popup').find('video')[0];
 		console.log("mainPopupVideo", mainPopupVideo);
 		if (mainPopupVideo) {
 			mainPopupVideo.muted = !mainPopupVideo.muted;
 			$(this).toggleClass("volume-muted", mainPopupVideo.muted);
 		}
 	});

 });

 $(document).ready(function() {

 	function isInViewport(theDiv) {
 		let elementTop = theDiv.offset().top;
 		let elementBottom = elementTop + theDiv.outerHeight();
 		let viewportTop = $(window).scrollTop();
 		let viewportBottom = viewportTop + window.innerHeight;
 		return elementBottom > viewportTop && elementTop < viewportBottom;
 	}
 	var animationDone = false;
 	if ($('#product-block-tested').length) {
 		$(window).on('scroll', function() {
 			if (!animationDone) {
 				if (isInViewport($('#product-block-tested'))) {
 					animationDone = true;
 					$(".circleBarProgress").each(function() {
 						var t = $(this).find(".circleBar"),
 							x = $(this).find(".circleBarWrapper"),
 							i = $(this).find("span"),
 							e = parseInt(i.text(), 10);
 						$({
 							p: 0
 						}).animate({
 							p: e
 						}, {
 							duration: 3e3,
 							easing: "swing",
 							step: function(e) {
 								x.css({
 									background: "conic-gradient(#FF6C84 0deg " + e + "%, #FEEAE8 " + e + "%)"
 								}), i.text(0 | e);

 							},
 						});
 					});
 				}
 			}
 		});
 	}
 });

 $("a").on('click', function(event) {
 	if ($(this).hasClass('redirect_rewart') == false) {
 		if ($(this).hasClass('shg-btn') == false && $(this).hasClass('redirect_rewart') == false) {
 			if (this.hash !== "") {
 				event.preventDefault();
 				var hash = this.hash;
 				$('html, body').animate({
 					scrollTop: $(hash).offset().top
 				}, 1000, function() {});
 			} // End if
 		}
 	}
 });

 // Add smooth scrolling to all links
 $("a").on('click', function(event) {
 	if ($(this).hasClass('shg-btn') == false && $(this).hasClass('redirect_rewart') == false) {
 		// Make sure this.hash has a value before overriding default behavior
 		if (this.hash !== "") {
 			// Prevent default anchor click behavior
 			event.preventDefault();

 			// Store hash
 			var hash = this.hash;

 			// Using jQuery's animate() method to add smooth page scroll
 			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
 			$('html, body').animate({
 				scrollTop: $(hash).offset().top - 120
 			}, 800, function() {

 				// Add hash (#) to URL when done scrolling (default click behavior)
 				// window.location.hash = hash;
 			});
 		} // End if
 	}
 });

 if ($('.custom-gallery-instafeed').length) {
 	$('.custom-gallery-instafeed').slick({
 		slidesToShow: 6,
 		dots: false,
 		arrows: false,
 		centerMode: false,
 		responsive: [{
 				breakpoint: 998,
 				settings: {
 					slidesToShow: 4,
 					slidesToScroll: 1,
 				},
 			},
 			{
 				breakpoint: 789,
 				settings: {
 					slidesToShow: 3,
 					slidesToScroll: 1,
 					centerMode: false,
 				},
 			},
 			{
 				breakpoint: 543,
 				settings: {
 					slidesToShow: 3,
 					slidesToScroll: 1,
 					centerMode: false,
 				},
 			}
 		],
 	});
 }

 if ($('.custom-instafeed-slider').length) {
 	$(".custom-instafeed-slider").slick({
 		arrows: false,
 		dots: false,
 		slidesToShow: 6,
 		centerMode: true,
 		centerPadding: '100px',
 		responsive: [{
 				breakpoint: 1024,
 				settings: {
 					slidesToShow: 4,
 					centerPadding: '50px',
 				}
 			},
 			{
 				breakpoint: 769,
 				settings: {
 					slidesToShow: 3,
 					centerPadding: '0px',
 				}
 			},
 			{
 				breakpoint: 480,
 				settings: {
 					slidesToShow: 2,
 					centerPadding: '30px',
 				}
 			},
 		]
 	});
 }

 //   $(document).on('click', '.collection-menu-item', function() {
 //   $(this).addClass('link-active');      
 //   $(this).siblings().removeClass('link-active');
 //   var dataTab = $(this).data('tab');
 //   $('.custom-collection-template .custom-collection-tab .product-item').hide();
 //   $('.custom-collection-template .custom-collection-tab .product-item.'+dataTab+'').show();

 //  var activeText = $(this).text();
 //   console.log(activeText);
 //   $('.collection-title').text(activeText);
 // });

 $(document).on('click', '.grid_list_item .item_list', function() {
 	$(this).addClass('active');
 	$(this).siblings().removeClass('active');
 	$('.product-list__inner').addClass('product_list_view');
 });

 $(document).on('click', '.grid_list_item .item_grid', function() {
 	$(this).addClass('active');
 	$(this).siblings().removeClass('active');
 	$('.product-list__inner').removeClass('product_list_view');
 });

 // Product slider
 var $slider = $('.product-slider-section .slider-product-wrapper');
 var $progressBar = $('.progress__bar, .progress__bar_item');
 var $progressBarLabel = $('.slider__label');

 // Set initial background size and aria-valuenow
 $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

 $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
 	var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

 	if (calc === 0) {
 		$progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
 	} else {
 		$progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
 	}

 	$progressBarLabel.text(calc + '% completed');
 });

 $slider.slick({
 	slidesToShow: 3,
 	slidesToScroll: 1,
 	arrows: true,
 	speed: 400,

 	appendArrows: '.slider-nav',
 	infinite: true, // Enable infinite looping
 	responsive: [{
 			breakpoint: 1200,
 			settings: {
 				slidesToShow: 2,
 				slidesToScroll: 1,
 			},
 		},
 		{
 			breakpoint: 789,
 			settings: {
 				slidesToShow: 2,
 				adaptiveHeight: false,
 				slidesToScroll: 1,
 			},
 		},
 	],
 });

 $(document).on('click', '.purchase-details__buttons .product-form__add-button', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.attr("disabled", true);
 	$this.append("<div class='custom_loader'></div>");
 	$this.find('span').hide();
 	$this.find('.add-icon').hide();
 	let upsellId = $this.closest('form').find('input[name=id]').val();
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				if (!document.getElementById('mini-cart').open == true) {
 					document.getElementById('mini-cart').open = true;
 				}
 				setTimeout(
 					function() {
 						$this.find('span').show();
 						$(".custom_loader").remove();
 						$this.attr("disabled", false);
 					}, 500);
 				shippingInsuranceAddRemove();
 			},
 			error: function(XMLHttpRequest) {
 				var response = eval('(' + XMLHttpRequest.responseText + ')');
 				if (response) {
 					response = response.description;
 					$('.warning').remove();
 					var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
 					$this.after(warning);
 				}
 			}
 		});
 	}

 });

 document.addEventListener("DOMContentLoaded", function() {
	// No legacy countdown on the rebranded homepage.
	if (!document.querySelector(".clock_timer")) return;
 	let clock;

 	function setTheCookie(name, value, days) {
 		let expires = "";
 		if (days) {
 			let date = new Date();
 			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
 			expires = "; expires=" + date.toUTCString();
 		}
 		document.cookie = name + "=" + value + expires + "; path=/";
 	}

 	function getTheCookie(name) {
 		let nameEQ = name + "=";
 		let ca = document.cookie.split(';');
 		for (let i = 0; i < ca.length; i++) {
 			let c = ca[i];
 			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
 			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
 		}
 		return null;
 	}


 	if (getTheCookie("countdownTimer_collection") !== "" || getTheCookie("countdownTimer_collection") !== null) {
 		console.log("time is alrea there =====================", getTheCookie("countdownTimer_collection"));
 	} else {
 		setTheCookie("countdownTimer_collection", 10, 1);
 		console.log("first tme set time =====================");
 	}

 	function startClock(initialTimerValue) {
 		clock = new FlipClock($(".clock_timer"), initialTimerValue, {
 			clockFace: "HourlyCounter",
 			countdown: true,
 			autoStart: true,
 			callbacks: {
 				stop: function() {
 					console.log("Timer has ended!");
 					// Restart the clock after it ends
 					clearCookie('countdownTimer_collection');
 					clearInterval(intervalId);
 					initialTimerValue = (2 * 60 + 13) * 60;
 					startClock(initialTimerValue);
 				},
 			},
 		});
 	}

 	function clearCookie(name) {
 		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
 	}

 	// Get the user's current time zone offset in minutes
 	let userTimeZoneOffset = moment().utcOffset() / 60;

 	// Set the reset time to 23:59:59 in the user's timezone
 	let currentDate = moment().utcOffset(userTimeZoneOffset);
 	let resetTime = currentDate.clone().endOf('day').hour(23).minute(59).second(59).unix();
 	let currentTime = moment().unix();
 	let diff = resetTime - currentTime;

 	if (diff <= 0) {
 		// If the time has passed for the day, set the reset time for the next day
 		resetTime += 24 * 60 * 60; // Add 24 hours in seconds
 		diff = resetTime - currentTime;
 	}

 	var savedTimerValue = getTheCookie("countdownTimer_collection");
 	console.log("save value ============================= ", savedTimerValue);

 	// Set the countdown timer to 2 hours and 13 minutes (2 hours * 60 minutes + 13 minutes)
 	let initialTimerValue = savedTimerValue ? parseInt(savedTimerValue) : (2 * 60 + 13) * 60;

 	// Run countdown timer
 	startClock(initialTimerValue);

 	// Save the remaining time in the cookie every second
 	intervalId = setInterval(function() {
 		setTheCookie("countdownTimer_collection", clock.getTime().time, 1);
 	}, 1000);



 });

 function calculateProgress(currentVal, targetVal) {
 	var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
 	var progressNum = document.querySelectorAll('.cart-shipping__num');
 	var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
 	var successMsg = document.querySelectorAll('.cart-shipping__success');
 	var result = Math.round(100 * currentVal / targetVal);
 	if (result <= 100) {
 		progressBar.forEach(function(el) {
 			// el.setAttribute('style', "width: ".concat(result, "%"));
 			el.setAttribute('style', 'width: 100%;');
 		})
 		$(".shipping-percentage-circle").text(result + "%");
 		$(".shipping-percentage-circle").css('left', 'calc(' + result + '% - 25px)');
 		// $(".shipping-percentage-circle").css('left', '-=25px');
 	} else {
 		progressBar.forEach(function(el) {
 			el.setAttribute('style', 'width: 100%;');
 		})
 		$(".shipping-percentage-circle").html('<img src="{{ "checkmark.png" | file_img_url: "master" }}" />');

 		$(".shipping-percentage-circle").css("left", "calc(100% - 25px)");
 	}
 	var newProgressNum = (targetVal - currentVal) / 100;
 	if (newProgressNum <= 0) {
 		successMsg.forEach(function(el) {
 			el.setAttribute('style', 'display: block;');
 		});
 		progressOuter.forEach(function(el) {
 			el.setAttribute('style', 'display: none;');
 		});
 		progressNum.forEach(function(el) {
 			el.textContent = newProgressNum;
 		});
 	} else {
 		successMsg.forEach(function(el) {
 			el.setAttribute('style', 'display: none;');
 		});
 		progressOuter.forEach(function(el) {
 			el.setAttribute('style', 'display: block;');
 		});
 		progressNum.forEach(function(el) {
 			el.textContent = newProgressNum;
 		});
 	}
 };

 function freeSample(cart) {
 	let freeSampleId = Shopify.freeSampleId;
 	if (!cart.items.length) return false
 	const freeSampleInCart = cart.items.some(item => item.id == freeSampleId)
 	if (cart.items.length == 1 && freeSampleInCart) {
 		freeSampleRemove()
 	}
 	if (cart.items.length != 0 && !freeSampleInCart) {
 		freeSampleAddToCart(freeSampleId)
 	}

 	function freeSampleAddToCart(id) {
 		$.ajax({
 			type: 'POST',
 			async: false,
 			url: '/cart/add.js',
 			dataType: 'json',
 			data: {
 				id: id,
 				quantity: 1
 			},
 			success: function() {
 				if (Shopify.template == 'cart') {
 					window.location.href = '/cart'
 				}
 			}
 		});
 	}

 	function freeSampleRemove() {
 		$.ajax({
 			type: 'POST',
 			async: false,
 			url: '/cart/clear.js',
 			dataType: 'json',
 			success: function() {
 				if (Shopify.template == 'cart') {
 					window.location.href = '/cart'
 				}
 			}
 		});
 	}
 }

 // Product page JS

 $(document).ready(function() {
 	if ($(".product_custmer_review .review_main").length > 0) {
 		$(".product_custmer_review .review_main").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			responsive: [{
 					breakpoint: 767,
 					settings: {
 						slidesToShow: 2,
 						slidesToScroll: 1,
 					}
 				},
 				{
 					breakpoint: 575,
 					settings: {
 						slidesToShow: 1,
 						slidesToScroll: 1,
 					}
 				}
 			]
 		});
 	}


 	$('.alternate-image-wrapper').slick({
 		slidesToShow: 1,
 		dots: true,
 		arrows: false
 	});

	function initSolutionProductsSlider() {
 		if (document.querySelector(".heading.solution-products")) {
 			$(".heading.solution-products").slick({
 				dots: false,
 				infinite: false,
 				arrows: true,
 				speed: 500,
 				slidesToShow: 3.3,
 				slidesToScroll: 3,
 				responsive: [{
 						breakpoint: 1024,
 						settings: {
 							slidesToShow: 3.3,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 799,
 						settings: {
 							slidesToShow: 2,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 600,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 480,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 				],
 			});
			return true;
 		}
		return false;
	}
	if (!initSolutionProductsSlider()) {
		var interval_2 = setInterval(function () {
			if (initSolutionProductsSlider()) clearInterval(interval_2);
		}, 500);
	}

	function initRecommendationSlider() {
 		if (document.querySelector(".products_recomendation")) {
 			$(".products_recomendation .cart-recomendation-product").slick({
 				dots: false,
 				infinite: false,
 				arrows: true,
 				speed: 500,
 				slidesToShow: 3.3,
 				slidesToScroll: 3,
 				responsive: [{
 						breakpoint: 1024,
 						settings: {
 							slidesToShow: 3.3,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 799,
 						settings: {
 							slidesToShow: 2,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 600,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 					{
 						breakpoint: 480,
 						settings: {
 							slidesToShow: 1,
 							slidesToScroll: 1,
 							infinite: true
 						}
 					},
 				],
 			});
			return true;
 		}
		return false;
	}
	if (!initRecommendationSlider()) {
		var interval = setInterval(function () {
			if (initRecommendationSlider()) clearInterval(interval);
		}, 500);
	}


 	$('.faq-question').click(function() {
 		$(this).siblings().slideToggle().parents('.product-faq-item').toggleClass('active');
 		$(this).parents('.product-faq-item').siblings().removeClass('active').find('.faq-answer').slideUp();
 	});

 	$('.ques-heading').click(function(j) {

 		var dropDown = $(this).closest('.questions__item_row').find('.ques-desc');
 		$(this).closest('.question-body').find('.ques-desc').not(dropDown).slideUp();

 		if ($(this).hasClass('qs_active')) {
 			$(this).removeClass('qs_active');
 		} else {
 			$('.ques-heading.qs_active').removeClass('qs_active');
 			$(this).addClass('qs_active');
 		}

 		dropDown.stop(false, true).slideToggle();
 		j.preventDefault();
 	});

 	$(".collapsible__btn").click(function() {
 		$(".collapsible__text_inside").slideToggle(350);
 	});

 });

 $(document).on('click', '.upsell-btn-js', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.find('span.add-text').hide();
 	$this.append("<div class='custom_loader'></div>");
 	let upsellId = $(this).attr('variant__id');
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));

 				setTimeout(
 					function() {
 						$this.find('span.added-text').fadeIn();
 						$this.removeClass('upsell-btn-js');
 						$(".custom_loader").remove();
 						// $this.closest('.bundle--inner_content').addClass('hide');
 					}, 1000);
 				shippingInsuranceAddRemove();
 			}
 		});
 	}

 });
 $(document).on('click', '.action_button.add_to_cart', function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.append("<div class='custom_loader'></div>");
 	$this.find('span').hide();
 	let upsellId = $this.closest('form').find('input[name=id]').val();;
 	if (upsellId) {
 		$.ajax({
 			type: 'POST',
 			url: '/cart/add.js',
 			data: {
 				quantity: 1,
 				id: upsellId
 			},
 			dataType: 'json',
 			success: function(data) {
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				document.getElementById('mini-cart').open = true;

 				setTimeout(
 					function() {
 						$this.find('span').show();
 						$(".custom_loader").remove();
 					}, 1000);
 				shippingInsuranceAddRemove();
 			}
 		});
 	}

 });

 $(document).ready(function() {
 	$('a.shipping-modal').click(function(e) {
 		e.preventDefault();
 		$('.modal.shipping-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.shipping-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});
 	$('a.value-props-modal').click(function(e) {
 		e.preventDefault();
 		$('.modal.value-props-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.value-props-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});

 	$('a.guarantee-value-props-modal').click(function(e) {
 		$('.modal.guarantee-value-props-modal').css('display', 'block');
 		$('body').css('overflow-y', 'hidden'); //Prevent double scrollbar.
 	});

 	$('.close-modal,.modal-sandbox').click(function(e) {
 		e.preventDefault();
 		$('.modal.guarantee-value-props-modal').css('display', 'none');
 		$('body').css('overflow-y', 'auto'); //Prevent double scrollbar.
 	});


 });
 //product video
 $(document).ready(function() {

 	$('.product-icon-volume').click(function() {
 		var activeVideo = $('.video-active video')[0];
 		if (activeVideo) {
 			activeVideo.muted = !activeVideo.muted;
 			$(this).toggleClass("volume-muted", activeVideo.muted);
 		}

 	});

 	function playPause(videoId, buttonId) {
 		var myVideo = document.getElementById(videoId);
 		var $button = $("#" + buttonId);

 		// Pause all other videos
 		$('video').not(myVideo).each(function() {
 			this.pause();
 			var otherButtonId = $(this).siblings(".video-control").attr('id');
 			$("#" + otherButtonId).removeClass("btnhide");
 			$("#" + otherButtonId).parents('.popup-video').removeClass('video-active');
 			$("#" + otherButtonId).parents('body').removeClass('video-popup-active');
 		});

 		if (myVideo.paused) {
 			myVideo.play();
 		} else {
 			myVideo.pause();
 		}

 		// Toggle class on the current button
 		$button.toggleClass("btnhide");
 		$button.parents('.popup-video').addClass('video-active');
 		$button.parents('body').addClass('video-popup-active');
 	}

 	function videoClose() {
 		var activeVideo = $('.video-active video')[0];
 		if (activeVideo) {
 			activeVideo.pause(); // Pause the active video
 			var activeButtonId = $(activeVideo).siblings(".video-control").attr('id');
 			$("#" + activeButtonId).removeClass("btnhide"); // Remove "btnhide" class from the button associated with the active video
 		}
 		$('body').removeClass('video-popup-active');
 		$('.popup-video').removeClass('video-active');
 	}

 	$(document).on("click", ".real-review-item .video-control", function() {

 		var clickedControl = $(this);
 		var clickedVideo = clickedControl.closest('.popup-video').find('video')[0];
 		var videoHtml = clickedControl.closest('.video-item').html();

 		// Move the video to the main popup
 		$('.review-main-popup').html(videoHtml);

 		// Pause all other videos
 		$('.popup-video video').not(clickedVideo).each(function() {
 			this.pause();
 			$(this).siblings('.video-control').removeClass('btnhide');
 		});

 		// Toggle play/pause and update control icon for the video in the main popup
 		var mainPopupVideo = $('.review-main-popup video')[0];
 		if (mainPopupVideo.paused) {
 			mainPopupVideo.play();
 			$('.review-main-popup .video-control').addClass('btnhide');
 		} else {
 			mainPopupVideo.pause();
 			$('.review-main-popup .video-control').removeClass('btnhide');
 		}

 		// Activate the main popup
 		$('.review-main-popup').addClass('video-active');
 		$('body').addClass('video-popup-active');
 	});

 	$(document).on("click", ".review-main-popup .icon-close", function() {
 		// Pause and close the video in the main popup
 		var mainPopupVideo = $('.review-main-popup video')[0];
 		if (mainPopupVideo) {
 			mainPopupVideo.pause();
 			$('.review-main-popup .video-control').removeClass('btnhide');
 		}

 		$('body').removeClass('video-popup-active');
 		$('.review-main-popup').removeClass('video-active');
 		$('.review-main-popup').empty();
 	});

 	$(document).on("click", ".review-main-popup .icon-volume", function() {
 		console.log("this = ", this);
 		var mainPopupVideo = $(this).parents('.review-main-popup').find('video')[0];
 		console.log("mainPopupVideo", mainPopupVideo);
 		if (mainPopupVideo) {
 			mainPopupVideo.muted = !mainPopupVideo.muted;
 			$(this).toggleClass("volume-muted", mainPopupVideo.muted);
 		}
 	});


 	$(document).on("click", ".review-tab-item", function() {
 		$(this).addClass('active');
 		$(this).siblings().removeClass('active');
 		var dataTab = $(this).data('href');
 		$(dataTab).addClass('active');
 		$(dataTab).siblings().removeClass('active');
 	});


 	if ($(".main-video-inner").length > 0) {
 		$(".main-video-inner").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			arrows: false,
 			responsive: [{
 				breakpoint: 741,
 				settings: {
 					slidesToShow: 2,
 					slidesToScroll: 1,
 				}
 			}]
 		});
 	}
 	if ($(".trust_review_slider").length > 0) {
 		$(".trust_review_slider").slick({
 			infinite: true,
 			slidesToShow: 3,
 			slidesToScroll: 1,
 			arrows: true,
 			responsive: [{
 					breakpoint: 1200,
 					settings: {
 						slidesToShow: 2,
 						slidesToScroll: 1,
 					}
 				},
 				{
 					breakpoint: 768,
 					settings: {
 						slidesToShow: 1,
 						slidesToScroll: 1,
 					}
 				}
 			]
 		});
 	}
 });

 document.addEventListener('variant:changed', function(event) {
 	let variant = event.detail.variant; // Gives you access to the whole variant details
 	let varTitle = variant.title;
 	console.log(varTitle);
 	let freegifts = 0;
 	switch (varTitle) {
 		case '1 Bottle':
 			freegifts = 1;
 			break;
 		case '2 Bottles':
 			freegifts = 2;
 			break;

 		case '3 Bottles':
 			freegifts = 3;
 			break;

 		case '4 Bottles':
 			freegifts = 4;
 			break;

 		default:
 			break;
 	}
 	var freeGifsDom = $('.free-gift-flex .free-gift-scooper');
 	$('.free-gift-flex .free-gift-scooper').removeClass('active');
 	$('.free-gift-flex .free-gift-scooper').find('input').attr("disabled", true);
 	for (var i = 0; i < freegifts; i++) {
 		$(freeGifsDom[i]).addClass('active');
 	}
 	$('.free-gift-flex .free-gift-scooper.active').find('input').attr("disabled", false);
 	$('#StickyAddToCart').addClass('main-atc-button--js');
 	$('#StickyAddToCart.main-atc-button--js').find('.loader-button__text').text('ADD TO CART');

 	$('.free-gifts-properties-js').empty();

 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		// console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});

 });

 function lockScroll() {
 	$html = $('html');
 	$body = $('body');
 	var initWidth = $body.outerWidth();
 	var initHeight = $body.outerHeight();

 	var scrollPosition = [
 		self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
 		self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
 	];
 	$html.data('scroll-position', scrollPosition);
 	$html.data('previous-overflow', $html.css('overflow'));
 	$html.css('overflow', 'hidden');
 	window.scrollTo(scrollPosition[0], scrollPosition[1]);

 	var marginR = $body.outerWidth() - initWidth;
 	var marginB = $body.outerHeight() - initHeight;
 	$body.css({
 		'margin-right': marginR,
 		'margin-bottom': marginB
 	});
 }

 function unlockScroll() {
 	$html = $('html');
 	$body = $('body');
 	$html.css('overflow', $html.data('previous-overflow'));
 	var scrollPosition = $html.data('scroll-position');
 	window.scrollTo(scrollPosition[0], scrollPosition[1]);

 	$body.css({
 		'margin-right': 0,
 		'margin-bottom': 0
 	});
 }

 $(document).on('click', '.main-atc-button--js', function(e) {
 	e.preventDefault();
 	e.stopPropagation();
 	$('#customAddToCart').click();
 	var $this = $(this);

 	$this.addClass('processing');
 	$this.find('span.loader-button__text').css('opacity', '0');
 	$this.find('span.loader-button__loader').addClass('show');
 	setTimeout(function() {
 		$this.find('span.loader-button__text').css('opacity', '1');
 		$this.find('span.loader-button__loader').removeClass('show');
 		$this.removeClass('processing');
 	}, 1500);

 });

 $('#customAddToCart').click(function(e) {
 	e.preventDefault();
 	$(this).find('span.loader-button__text').hide();
 	$(this).find('span.loader-button__loader').css('display', 'contents');
 	let addToCartForm = document.querySelector('form.free-gifts-form.active');
 	let formData = new FormData(addToCartForm);
 	$('form.free-gifts-form.active input.js-product_id_input:not(:disabled)').each(function(index, data) {
 		var value = $(this).val();
 		var newInput = `<input type="hidden" name="properties[_free gift ${index}]" value= "${value}">`;
 		// console.log(newInput);
 		$('.free-gifts-properties-js').append(newInput);

 	});
 	$.ajax({
 		type: "POST",
 		url: '/cart/clear.js',
 		data: '',
 		dataType: 'json',
 		success: function() {
 			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 				bubbles: true
 			}));
 			fetch(window.Shopify.routes.root + 'cart/add.js', {
 					method: 'POST',
 					body: formData
 				})
 				.then(response => {
 					$('#AddToCart').click();
 					// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					//              bubbles: true
 					//             }));

 					// return response.json();
 				})
 				.catch((error) => {
 					alert(error);
 					console.error('Error:', error);
 				});
 			setTimeout(function() {
 				$('#customAddToCart').find('span.loader-button__text').show();
 				$('#customAddToCart').find('span.loader-button__loader').hide();
 			}, 1000);
 		},
 		error: function(XMLHttpRequest, textStatus) {
 			/* error code */
 		}
 	});

 });


 // Code below has been updated by Naveed to resolve the cart drawer issue .

   document.addEventListener('cart:updated', function(event) {
     var cart = event.detail.cart; 
     console.log(cart,"Cart Update **********************");
         checkAndRefreshCartDrawer(cart);
 });

 function checkAndRefreshCartDrawer(cart) {

     var freeGiftProductHandles = ['free-ebook-sca_clone_freegift', 'free-shipping-1-sca_clone_freegift', 'free-lash-curler-sca_clone_freegift', 'free-mascara-sca_clone_freegift'];

     var anyFreeGiftsInCart = freeGiftProductHandles.some(function(handle) {
         return cart.items.some(function(item) {
             return item.handle === handle;
         });
     });


     var drawerContainsFreeGift = freeGiftProductHandles.some(function(handle) {
         return $('.drawer__content').find(`[data-cart-item-handle="${handle}"]`).length > 0;
     });

     if ((anyFreeGiftsInCart && !drawerContainsFreeGift) || (!anyFreeGiftsInCart && drawerContainsFreeGift)) {

         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true
         }));
       console.log('Cart drawer refreshed due to a mismatch between the cart and the drawer.');
     } else {

         console.log('Cart and drawer are in sync. No refresh needed.');
     }
 }




  /* The delegated remove handler that used to live here fired on the SAME click as
     the one above — a remove link carries both .link.main-product--true and
     .line-item__remove-button.main-product--true — so one click sent two
     /cart/update.js calls plus a /cart/change.json per gift, all racing on the
     same cart. That is what intermittently left the main line behind.
     Removed 2026-08-07; the handler above now does the whole job. */


 $(".scroll-to-bundle--js").click(function(e) {
 	e.preventDefault();
 	$('html,body').animate({
 			scrollTop: $(".product_bundle_wrapper").offset().top - 160
 		},
 		'slow');
 });

 $(".scroll-to-product-form--js").click(function(e) {
 	e.preventDefault();
 	$('html,body').animate({
 			scrollTop: $(".product__info").offset().top - 160
 		},
 		'slow');
 });

 $('.bundle-atc-custom').click(function(e) {
 	e.preventDefault();
 	var $this = $(this);
 	$this.addClass('button--loading');
 	$this.find('span.loader-button__text').hide();
 	$this.find('span.loader-button__loader').css('display', 'contents');

 	$.ajax({
 		type: "POST",
 		url: '/cart/clear.js',
 		data: '',
 		dataType: 'json',
 		success: function() {
 			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 				bubbles: true
 			}));
 			$this.next('.bundle-atc-custom--main').click();
 			setTimeout(function() {
 				$this.removeClass('button--loading');
 				$this.find('span.loader-button__text').show();
 				$this.find('span.loader-button__loader').hide();
 			}, 1000);
 		},
 		error: function(XMLHttpRequest, textStatus) {
 			/* error code */
 		}
 	});

 });

 function isElementInViewport(el) {
 	var rect = el.getBoundingClientRect();
 	return (
 		rect.top >= 0 &&
 		rect.left >= 0 &&
 		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
 		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
 	);
 }

 // $(window).scroll(function() {
 //     var scrollPosition = $(this).scrollTop();
 //     var productBundleSection = $('.product_bundle_section')[0];
 //     var customProductForm = $('.custom-product-sticky-form');

 //     if (scrollPosition > 500 || isElementInViewport(productBundleSection)) {
 //         customProductForm.removeAttr('hidden'); // Remove the hidden attribute when productBundleSection is in viewport
 //     } else {
 //         customProductForm.attr('hidden', true); // Add the hidden attribute otherwise
 //     }
 // });

 // // Function to check if an element is in the viewport
 // function isElementInViewport(el) {
 //     var rect = el.getBoundingClientRect();
 //     return (
 //         rect.top >= 0 &&
 //         rect.left >= 0 &&
 //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
 //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
 //     );
 // }
 $(window).scroll(function() {
 	if ($(this).scrollTop() > 500) {
 		$('.custom-product-sticky-form').removeAttr('hidden');
 	} else {
 		$('.custom-product-sticky-form').attr('hidden', true);
 	}
 });

 $(window).scroll(function() {
 	if ($('.product_bundle_section').length) {
 		var viewportTopBundle = $(window).scrollTop();
 		var viewportBottomBundle = viewportTopBundle + $(window).height();
 		var elementTopBundle = $('.product_bundle_section').offset().top;
 		var elementBottomBundle = elementTopBundle + $('.product_bundle_section').outerHeight();

 		// Check if the element is in the viewport
 		if ((elementBottomBundle >= viewportTopBundle) && (elementTopBundle <= viewportBottomBundle)) {
 			// If the element is in the viewport, trigger alert
 			$('.custom-product-sticky-form').attr('hidden', true);
 		}
 	}
 });


 $(document).ready(function() {
 	var lastScrollTop = 0;

 	$(window).scroll(function() {
 		var currentScrollTop = $(this).scrollTop();

 		if (currentScrollTop < lastScrollTop) {
 			// Scrolling up
 			$('.scroll-top').addClass('scroll-top--active');
 		} else {
 			// Scrolling down
 			$('.scroll-top').removeClass('scroll-top--active');
 		}

 		lastScrollTop = currentScrollTop;
 	});

 	if ($('#stock-number').length) {

 		function updateStockNumber() {
 			let stockNumber = document.getElementById('stock-number');
 			let currentNumber = parseInt(stockNumber.innerText);
 			let decreaseAmount = Math.floor(Math.random() * 5) + 1; // Random decrease between 1 and 5
 			let newNumber = currentNumber - decreaseAmount;

 			if (newNumber > 0) {
 				stockNumber.innerText = newNumber;
 			} else {
 				// Restart the counter from the starting value
 				parseInt(stockNumber.getAttribute('data-order'));
 			}
 		}

 		// Initial update after 2-3 seconds
 		setTimeout(updateStockNumber, Math.floor(Math.random() * 2001) + 2000); // Random time between 2000ms and 4000ms

 		// Random updates every 5 seconds
 		setInterval(() => {
 			setTimeout(updateStockNumber, Math.floor(Math.random() * 3001) + 2000); // Random time between 2000ms and 5000ms
 		}, 5000);
 	}

 });



 // Menu drawer js
 $(document).ready(function() {
 	$('.mobile-item-title').on('click', function() {
 		$(this).parents('.mobile-nav__item_new').addClass('menu-active');
 		$(this).parents('.mobile-nav__item_new').siblings().removeClass('menu-active');

 	});



 	$('.drawer__close-button').on('click', function() {
 		$('.mobile-nav__item_new').removeClass('menu-active');
 	});


 	$('.mobile-item-title-v3').click(function() {
 		$(this).siblings('.menu-item-content-v3').slideToggle();
 		$(this).find('.has_sub_icon svg').toggle();
 	});

 	$('.tab_heading_item').click(function() {
 		$(this).addClass('active');
 		$(this).siblings().removeClass('active');
 		var menuTarget = $(this).data('tab');
 		$(this).parents('.mobile_menu_tab').find('.nav_tab_content #' + menuTarget).addClass('active');
 		$(this).parents('.mobile_menu_tab').find('.nav_tab_content #' + menuTarget).siblings().removeClass('active');
 	});

 	$(document).on('click', '.click_gift', function() {
 		var $this = $(this);
 		shippingInsuranceAddRemoveCall($this);
 		console.log("function call==================");
 	});
 });

 function shippingInsuranceAddRemoveCall($this) {
 	var shippingInsurance = false;
 	var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 	var shippingID = '56632414896433';
 	$.ajax({
 		type: 'GET',
 		url: '/cart.json',
 		dataType: 'jsonp',
 		success: function(data) {
 			var items = data['items'];
 			for (var i = 0; i < items.length; i++) {
 				if (items[i]["handle"] == shippingHandle) {
 					shippingInsurance = true;
 				}
 			}
 			if (items.length >= 1) {
 				if ($this.is(':checked')) {
 					if (!shippingInsurance) {
 						shippingAddProduct(shippingID);
 					}
 				} else {
 					shippingRemoveProduct(shippingID);
 				}
 			}
 		}
 	});
 }

 function shippingAddProduct(variantID) {
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/add.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', true);
 			} else {
 				console.error('Error adding product to cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"quantity": 1,
 		"id": variantID
 	});

 	xhr.send(data);
 }

 function shippingRemoveProduct(shippingID) {
 	var variantIDString = shippingID.toString();
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/change.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', false);
 			} else {
 				console.error('Error removing product from cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"id": variantIDString,
 		"quantity": 0
 	});

 	xhr.send(data);
 }


 // lip plumper Variant Dropdown
 $('.custom_variaent_select').change(function() {
 	var variantImg = $(this).find('option:selected').data('variantimg');
 	var variantDesc = $(this).find('option:selected').data('variantdesc');
 	var variantValue = $(this).find('option:selected').data('variantvalue');
 	var selectVariantId = $(this).find('option:selected').data('selectvariantid');
 	var mainImgId = $(this).find('option:selected').data('mainimgid');
 	var mainFirstImg = $(this).find('option:selected').data('mainfirstimg');
 	var mainSecondImg = $(this).find('option:selected').data('mainsecondimg');
 	var mainMediaId = $(this).find('option:selected').data('mediaid');


 	// Change Select Box 

 	setTimeout(function() {
 		console.log("clicked version=====================", $('.comboBox_button').find('.select__selected-value').length);
 		$('.comboBox_button').find('.select__selected-value').html(`<span class="img-wrap"><img src="${variantImg}" alt=""></span><span class="text"><span class="name">${variantValue}</span> <span class="desc">${variantDesc}</span></span>`);
 	}, 0);

 	// Change Product Thumbnail 
 	$('.product__thumbnail-item.is-variantImg').removeClass('active');
 	$(this).parents('.product').find('.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]').prop('aria-current', '');
 	$(this).parents('.product').find('.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]').addClass('active');
 	$(this).parents('.product').find('.product__thumbnail-item.variant-first_img[data-variantitem="' + selectVariantId + '"]').attr('aria-current', true);

 	// Change Main Image 
 	$(this).parents('.product').find('.main-second-image').attr('id', mainImgId + '-2').attr('data-media-id', mainMediaId);
 	$(this).parents('.product').find('.main-second-image img').attr('src', mainSecondImg).attr('srcset', mainSecondImg);

 	$(this).parents('.product').find('.main-first-image').attr('id', mainImgId).attr('data-media-id', mainMediaId);
 	$(this).parents('.product').find('.main-first-image img').attr('src', mainFirstImg).attr('srcset', mainFirstImg);



 });


 $(document).ready(function() {
 	// Product Upsell 1
 	$('.upsell-version-1 .upsell_slider_list').slick({
 		slidesToShow: 2,
 		dots: false,
 		arrows: true,
 		appendArrows: '.upsell_nav1',
 		responsive: [{
 			breakpoint: 768,
 			settings: {
 				slidesToShow: 3,
 			}
 		}]
 	});



 	// Product Upsell 1
 	$('.upsell-version-2 .upsell_slider_list').slick({
 		slidesToShow: 2,
 		dots: false,
 		arrows: true,
 		appendArrows: '.upsell_nav2',
 		responsive: [{
 			breakpoint: 768,
 			settings: {
 				slidesToShow: 3,
 			}
 		}]
 	});


 });



 function shippingInsuranceAddRemove() {
 	if ($('body').hasClass("shipping-insurance")) {
 		var shippingInsurance = false;
 		var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 		var shippingID = '56632414896433';
 		var $this = $(this);
 		$.ajax({
 			type: 'GET',
 			url: '/cart.json',
 			dataType: 'jsonp',
 			success: function(data) {
 				var items = data['items'];
 				for (var i = 0; i < items.length; i++) {
 					if (items[i]["handle"] == shippingHandle) {
 						shippingInsurance = true;
 					}
 				}
 				if (items.length >= 1) {
 					if (!shippingInsurance) {
 						shippingAddProduct(shippingID);
 						setTheCookie("ShippingProtection", "1", 1);
 						console.log("shippingInsurance true=====================");
 					}
 				}
 				if (shippingInsurance) {
 					if (items.length == 1) {
 						shippingRemoveProduct(shippingID);
 					}
 				}
 			}
 		});
 	}
 }

 function shippingInsuranceRemoveOnQuantityChange() {
 	var shippingInsurance = false;
 	var shippingHandle = 'shipping-insurance-coverage-for-lost-packages-of-up-to-250-v1';
 	var shippingID = '56632414896433';
 	$.ajax({
 		type: 'GET',
 		url: '/cart.json',
 		dataType: 'jsonp',
 		success: function(data) {
 			var items = data['items'];
 			for (var i = 0; i < items.length; i++) {
 				if (items[i]["handle"] == shippingHandle) {
 					shippingInsurance = true;
 				}
 			}
 			if (items.length == 1) {
 				if (shippingInsurance) {
 					shippingRemoveProduct(shippingID);
 				}
 			}
 		}
 	});
 }

 function shippingAddProduct(variantID) {
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/add.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', true);
 			} else {
 				console.error('Error adding product to cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"quantity": 1,
 		"id": variantID
 	});

 	xhr.send(data);
 }

 function shippingRemoveProduct(shippingID) {
 	var variantIDString = shippingID.toString();
 	var xhr = new XMLHttpRequest();
 	var url = "/cart/change.js";
 	xhr.open("POST", url, true);
 	xhr.setRequestHeader("Content-Type", "application/json");

 	xhr.onreadystatechange = function() {
 		if (xhr.readyState === 4) {
 			if (xhr.status === 200) {
 				if (window.location.href.indexOf("cart") > -1) {
 					location.reload();
 				}
 				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 					bubbles: true
 				}));
 				// updateCartBubble();
 				$('.click_gift').prop('checked', false);
 			} else {
 				console.error('Error removing product from cart:', xhr.status, xhr.statusText);
 			}
 		}
 	};

 	var data = JSON.stringify({
 		"id": variantIDString,
 		"quantity": 0
 	});

 	xhr.send(data);
 }




 // // Upsell Version 1
 // document.addEventListener("DOMContentLoaded", function(event) {
 //   var upsellVersion = document.getElementsByClassName('product_upsell_main')[0];
 //   upsellVersion.classList.add('upsell-item-1');
 // });

 // // Upsell Version 2
 // document.addEventListener("DOMContentLoaded", function(event) {
 //   var upsellVersion = document.getElementsByClassName('product_upsell_main')[0];
 //   upsellVersion.classList.add('upsell-item-2');
 // });


 document.addEventListener('DOMContentLoaded', function() {
 	const toggle = document.querySelector('.subscription-toggle');
 	const form = document.querySelector('.shopify-product-form');

 	if (!toggle || !form) return;

 	function handleSellingPlanInput() {
 		const existingInput = form.querySelector('input[name="selling_plan"]');

 		if (toggle.classList.contains('active')) {
 			if (!existingInput) {
 				const input = document.createElement('input');
 				input.type = 'hidden';
 				input.name = 'selling_plan';
 				input.value = '';
 				form.appendChild(input);
 			}
 		} else if (existingInput) {
 			existingInput.remove();
 		}
 	}

 	// Run once on page load
 	handleSellingPlanInput();

 	const observer = new MutationObserver(handleSellingPlanInput);
 	observer.observe(toggle, {
 		attributes: true,
 		attributeFilter: ['class']
 	});
 });

// product sticky add to cart
 $('.product-sticky-form .product-form__add-button').on("click", function() {
	  $('.product__info .product-form__buy-buttons .product-form__add-button').trigger('click');
 });

/* ==========================================================================
   28 rebrand — behaviour lifted out of the snippets, 2026-08-07
   Both blocks used to sit inline: the scroll bar in 28-forchics-rebranding
   and the countdown in 28-announcement-1. This file is already deferred at
   the end of body, so the DOM is parsed by the time either runs, and the
   two blocks stop shipping ~30kB of inline script in every page's HTML.
   ========================================================================== */

/* --- custom scroll progress bar (was snippets/28-forchics-rebranding.liquid) --- */
(function () {
  var root = document.documentElement;
  var bar, timer, unusable = false;

  function ensure() {
    if (unusable) return null;
    if (bar || !document.body) return bar;
    bar = document.createElement('div');
    bar.className = 'scrollbar-28';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    /*
      The .scrollbar-28 rule that lifts this out of flow lives in
      snippets/28-forchics-rebranding.liquid, and theme.liquid renders that
      snippet only for the suffixes in rebranded_templates. This file loads on
      every template, so everywhere else the div landed in normal flow as a
      static block and the height set below became real page height: a white
      band under the footer, on every non-28 template. Worse, it fed back on
      itself - the thumb is sized from root.scrollHeight, and the stray node
      inflates scrollHeight, so the page grew on each scroll. It also only
      appeared after the first scroll, since nothing creates the node until
      then, which is why a plain page load looked clean.

      So confirm the stylesheet is actually on this page. If the node is not
      out of flow, remove it and never build it again.
    */
    if (window.getComputedStyle(bar).position !== 'fixed') {
      if (bar.parentNode) bar.parentNode.removeChild(bar);
      bar = null;
      unusable = true;
      return null;
    }
    return bar;
  }

  function draw() {
    var page = root.scrollHeight;
    var view = window.innerHeight;
    if (page <= view + 1) {
      if (bar) bar.style.height = '0px';
      return;
    }
    var el = ensure();
    if (!el) return;
    var thumb = Math.max(28, (view * view) / page);
    var travel = (window.scrollY / (page - view)) * (view - thumb);
    el.style.height = thumb + 'px';
    el.style.transform = 'translateY(' + travel + 'px)';
  }

  function show() {
    draw();
    root.classList.add('is-scrolling');
    clearTimeout(timer);
    timer = setTimeout(function () {
      root.classList.remove('is-scrolling');
    }, 800);
  }

  document.addEventListener('scroll', show, true);
  window.addEventListener('wheel', show, { passive: true });
  window.addEventListener('touchmove', show, { passive: true });
  window.addEventListener('resize', draw);
})();

/* --- announcement countdown (was snippets/28-announcement-1.liquid) ---
   The original awaited https://ipapi.co/json/ before the first tick, purely
   to learn the visitor's timezone — a third-party DNS, TLS and round trip on
   the critical path for a cosmetic clock, on a free tier that rate-limits.
   Intl already reports the visitor's own timezone with no network at all, and
   it was the fallback anyway, so the fetch is gone.

   Behaviour is otherwise unchanged: on July 4 it counts down to midnight,
   every other day it runs a repeating 35-minute cycle. */
// (function () {
//   var hoursEl, minutesEl, secondsEl;

//   function parts(date) {
//     var got = new Intl.DateTimeFormat('en-US', {
//       year: 'numeric', month: 'numeric', day: 'numeric',
//       hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
//     }).formatToParts(date);
//     var out = {};
//     got.forEach(function (p) { if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10); });
//     return out;
//   }

//   function paint(remaining) {
//     hoursEl.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
//     minutesEl.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
//     secondsEl.textContent = String(remaining % 60).padStart(2, '0');
//   }

//   function tick() {
//     hoursEl = hoursEl || document.getElementById('js-clock-hours');
//     minutesEl = minutesEl || document.getElementById('js-clock-minutes');
//     secondsEl = secondsEl || document.getElementById('js-clock-seconds');
//     if (!hoursEl || !minutesEl || !secondsEl) return;

//     var local = parts(new Date());

//     if (local.month === 7 && local.day === 4) {
//       paint((23 - local.hour) * 3600 + (59 - local.minute) * 60 + (59 - local.second));
//       return;
//     }

//     var elapsed = local.hour * 3600 + local.minute * 60 + local.second;
//     var remaining = 7980 - (elapsed % 7980);
//     paint(remaining === 7980 ? 0 : remaining);
//   }

//   tick();
//   setInterval(tick, 1000);
// })();

// The retired July 4 countdown made an unused IP lookup.
// The active countdown remains in snippets/announcement-v2.liquid.
